module.exports = __webpack_public_path__ + "static/media/authentic-taco-cabreras.6b3e1ca1.jpg";